import { createClient } from '@supabase/supabase-js';

// Supabase configuration
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

if (!supabaseUrl || !supabaseAnonKey) {
  const errorMessage = 
    '⚠️  Supabase environment variables are missing!\n' +
    'Please set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in Vercel Environment Variables.\n' +
    `Current values: URL=${supabaseUrl ? 'SET' : 'MISSING'}, KEY=${supabaseAnonKey ? 'SET' : 'MISSING'}`;
  
  console.error(errorMessage);
  
  // Throw error to prevent app from running with invalid config
  throw new Error(
    'Supabase configuration missing. ' +
    'Please set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in Vercel Environment Variables.'
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Database types
export interface TemporaryReservation {
  id: string;
  date: string;
  time: string;
  location?: string;
  service_type: 'store' | 'home';
  expires_at: string;
  session_id: string;
  google_calendar_event_id?: string;
  created_at: string;
}

export interface Appointment {
  id: string;
  order_number: string;
  customer_name: string;
  customer_email: string;
  customer_phone?: string;
  date: string;
  time: string;
  location?: string;
  service_type: 'store' | 'home';
  google_calendar_event_id?: string;
  status: 'pending' | 'confirmed' | 'cancelled';
  created_at: string;
  updated_at: string;
}

